export default "__VITE_ASSET__BS70pQpC__"